module.exports = __webpack_public_path__ + "static/media/work-done-icon.e532e706.svg";